"use client";

import { CitationTool } from "@/components/citation-tool";
import { getFeaturedStyles } from "@/data/citation-styles";

/**
 * Live citation generator embedded on the Email landing page. The tool opens straight on
 * the manual-entry tab preset to the "Personal communication" source type (CSL
 * `personal_communication`), which covers emails, letters, and private messages. Users
 * type the sender, description, and date and pick any of the 10,834 styles.
 */
export default function EmailCitationGeneratorWidget() {
  return (
    <CitationTool
      initialManualType="personal_communication"
      initialMode="manual"
      styles={getFeaturedStyles()}
    />
  );
}
